import type { RiskLevel } from '@/domains/shared';

/**
 * Interface para las constantes de los niveles de riesgo
 */
export interface RiskLevelConst {
  key: RiskLevel;
  label: RiskLevel;
}

/**
 * Constantes utilizadas para reprecentar los niveles de riesgo
 */
export const RISK_LEVEL: RiskLevelConst[] = [
  { key: 'bajo', label: 'bajo' },
  { key: 'medio', label: 'medio' },
  { key: 'alto', label: 'alto' },
];

/**
 * Constante con indicadores de riesgo de la aplicación
 */
export const RISK_INDICATORS = [
  // agregar tipado si es necesario
  'asistencia',
  'evaluaciones',
  'beneficios',
  'socioeconómico',
  'otros',
];
